<template>
<svg 
	 xmlns="http://www.w3.org/2000/svg"
	 viewBox="-11.5 780.5 24 24" >
<path d="M10.38,782.5c0.04,4.19-0.43,8.02-4.21,9.65c-4.58,1.97-1.96,4.96,2.43,3.46c-3.18,2.72-6.08,5.91-8.39,6.68
	c-0.28,0.13-0.6,0.2-0.92,0.2c-0.48,0-0.92-0.15-1.29-0.4c-1.32,0.36-2.47,0.47-3.44,0.38c-0.83-0.01-1.6-0.28-2.23-0.73
	c-2.09-1.4-2.31-4.58-0.49-8.4c-0.07-0.36-0.04-0.71,0.05-1.06c0.08-0.4,0.26-0.76,0.51-1.06c1.21-1.79,4.06-3.47,6.66-5.2
	c-3.25,4.14-2.81,5.97-0.44,3.93c-0.04-0.32,0.05-0.63,0.25-0.97c0.08-0.14,0.17-0.27,0.28-0.39c0.75-0.94,2.18-2.08,3.63-3.84
	C1.2,792.52,6.87,788.23,10.38,782.5L10.38,782.5z M0.5,788.78c-0.58,0-1.05,0.47-1.05,1.05s0.47,1.05,1.05,1.05
	c0.59,0,1.05-0.47,1.05-1.05S1.08,788.78,0.5,788.78z M-5.66,791.07c-0.95,0-1.71,0.76-1.71,1.71c0,0.95,0.76,1.71,1.71,1.71
	c0.21,0,0.42-0.04,0.61-0.11c0.03-0.81,0.44-1.52,1.06-1.97C-4.16,791.64-4.84,791.07-5.66,791.07L-5.66,791.07z M-2.51,792.72
	c-0.98,0-1.76,0.78-1.76,1.76s0.78,1.76,1.76,1.76c0.98,0,1.76-0.79,1.76-1.76S-1.53,792.72-2.51,792.72L-2.51,792.72z
	 M-5.39,795.45c-1.73,0-3.12,1.39-3.12,3.12c0,1.73,1.39,3.12,3.12,3.12c0.98,0,1.85-0.45,2.42-1.14c-0.02-0.12-0.03-0.24-0.03-0.37
	c0-0.66,0.28-1.26,0.73-1.68c-0.01-0.54-0.16-1.05-0.41-1.49c-0.97-0.06-1.79-0.67-2.16-1.52C-5.02,795.47-5.2,795.45-5.39,795.45
	L-5.39,795.45z M0.69,795.89c-0.53,0-0.95,0.42-0.95,0.95c0,0.53,0.42,0.95,0.95,0.95s0.95-0.42,0.95-0.95
	C1.63,796.31,1.21,795.89,0.69,795.89L0.69,795.89z M-0.7,798.66c-0.84,0-1.52,0.68-1.52,1.52c0,0.84,0.68,1.52,1.52,1.52
	s1.52-0.68,1.52-1.52C0.82,799.34,0.14,798.66-0.7,798.66L-0.7,798.66z"/>
</svg>

</template>